/* eslint-disable camelcase */
jQuery(document).ready(function ($) {
	const $preloader = document.querySelector('.preloader');
	let isInitializing = true; // Flag to prevent AJAX during initialization

	if (document.referrer) {
		sessionStorage.setItem('previousPage', document.referrer);

		$(window).on('popstate', function () {
			const previousPage = sessionStorage.getItem('previousPage');
			if (previousPage) {
				window.location.href = previousPage;
			}
		});
	}

	initFilters();

	// Mark initialization as complete after a delay
	// Wait for DOM to be fully ready and all handlers to be set up
	// Use longer delay to ensure no AJAX is triggered during initial page load
	setTimeout(function () {
		isInitializing = false;
	}, 1000);

	function initFilters() {
		const $filterSelects = $('.filter-select');
		const $filtersTop = $('.filters__top');
		const $filtersBox = $('.filters__top-filters');
		const $triggerTablet = $('.filters__top-opener');

		if (!$filterSelects.length) {
			return;
		}

		// === Сначала чистим прошлые обработчики ===
		$(document).off('.filters'); // снимаем все в namespace .filters
		$triggerTablet.off('.filters');
		$filterSelects.find('.filter-select__trigger').off('.filters');
		$filterSelects.find('input[type="checkbox"]').off('.filters');

		// === Заново навешиваем ===
		if (
			window.innerWidth < 1025 &&
			$triggerTablet.length &&
			$filtersBox.length
		) {
			$triggerTablet.on('click.filters', function (e) {
				e.stopPropagation();
				$filtersTop.toggleClass('active');
				$filtersBox.stop(true, true).slideToggle(300);
			});

			$(document).on('click.filters', function (e) {
				if (
					!$filtersTop.is(e.target) &&
					$filtersTop.has(e.target).length === 0
				) {
					$filtersTop.removeClass('active');
					$filtersBox.stop(true, true).slideUp(300);
				}
			});
		}

		$filterSelects.each(function () {
			const $selectBox = $(this);

			const $trigger = $selectBox.find('.filter-select__trigger');
			const $options = $selectBox.find('.filter-select__options');
			const $checkboxes = $options.find('input[type="checkbox"]');
			const $realSelect = $selectBox.find('select.real-select');

			if (
				!$trigger.length ||
				!$options.length ||
				!$checkboxes.length ||
				!$realSelect.length
			) {
				return;
			}

			setupTrigger($selectBox, $trigger, $options);
			setupOutsideClickHandler($selectBox, $options);
			setupCheckboxChangeHandler($checkboxes, $realSelect);
		});

		setupResetFiltersHandler();
		setupCardCategoryButtons();

		// Only apply filters from URL if they exist (initial load is server-rendered)
		const urlParams = new URLSearchParams(window.location.search);
		const filters = urlParams.get('filters');
		if (filters) {
			applyFiltersFromUrl();
		} else {
			// Just update choices display if needed
			updateChoises();
		}
	}

	function setupTrigger($selectBox, $trigger, $options) {
		$trigger.on('click', function (e) {
			e.stopPropagation();

			if (!$selectBox.length || !$options.length) {
				return;
			}

			if ($selectBox.hasClass('active')) {
				closeFilter($selectBox, $options);
			} else {
				closeAllFilters();
				openFilter($selectBox, $options);
			}
		});
	}

	function setupOutsideClickHandler($selectBox, $options) {
		$(document).on('click', function (e) {
			if (!$selectBox.length || !$options.length) {
				return;
			}

			if (
				!$selectBox.is(e.target) &&
				$selectBox.has(e.target).length === 0
			) {
				closeFilter($selectBox, $options);
			}
		});
	}

	function setupCheckboxChangeHandler($checkboxes, $realSelect) {
		$checkboxes.on('change', function () {
			// Don't trigger AJAX during initialization (initial content is server-rendered)
			if (isInitializing) {
				return;
			}

			if (!$checkboxes.length || !$realSelect.length) {
				return;
			}

			const $this = $(this);
			const isClear = $this.val() === 'clear';

			if (isClear) {
				$checkboxes.prop('checked', false);
				$realSelect.find('option').prop('selected', false);
				$this.prop('checked', false);
			} else {
				$checkboxes.filter('[value="clear"]').prop('checked', false);
			}

			syncRealSelect($checkboxes, $realSelect);
			updateChoises();
			updateUrlParams();
		});
	}

	function setupCardCategoryButtons() {
		$('.success-stories-card__category')
			.off('click')
			.on('click', function () {
				const slug = $(this).data('slug');

				if (!slug) {
					return;
				}

				const $checkbox = $(
					`.filter-select__option input[type="checkbox"][value="${slug}"]`
				);

				if ($checkbox.length) {
					if (!$checkbox.prop('checked')) {
						$checkbox.prop('checked', true).trigger('change');
					}
				}
			});
	}

	function updateUrlParams() {
		// Don't trigger AJAX during initialization (initial content is server-rendered)
		if (isInitializing) {
			return;
		}

		const selectedTerms = getAllCheckedTerms();
		const urlParams = new URLSearchParams(window.location.search);

		if (selectedTerms.length > 0) {
			urlParams.set('filters', selectedTerms.join(','));
		} else {
			urlParams.delete('filters');
		}

		// Remove page params when filtering (always start from page 1)
		urlParams.delete('paged');
		urlParams.delete('page');

		// Remove path-based pagination from pathname (e.g., /page/3/)
		let cleanPathname = window.location.pathname.replace(
			/\/page\/\d+\/?$/,
			''
		);
		// Ensure path ends with / if it's not empty
		if (cleanPathname && !cleanPathname.endsWith('/')) {
			cleanPathname = cleanPathname + '/';
		}
		// If pathname is empty after cleaning, use root
		if (!cleanPathname || cleanPathname === '/') {
			cleanPathname = '/case-studies/';
		}

		const urlString = '?' + urlParams.toString();
		const finalUrl =
			urlString === '?' ? cleanPathname : cleanPathname + urlString;

		// Update URL and perform AJAX request (smooth filtering)
		history.pushState(null, '', finalUrl);
		performAjaxFilterRequest(1); // Always start from page 1 when filtering
	}

	function updateChoises() {
		const $choisesContainer = $('.filters__choises');
		$choisesContainer.empty();

		$('.filter-select__option input[type="checkbox"]:checked').each(
			function () {
				const $checkbox = $(this);
				const value = $checkbox.val();
				if (value === 'clear') {
					return;
				}

				const text = $checkbox
					.closest('label')
					.find('.filter-select__text')
					.text()
					.trim();

				const $button = $(`
        <button class="filter-choice-btn button-rem button-rem-filter" data-value="${value}">
          ${text} <span class="remove">&times;</span>
        </button>
      `);

				$choisesContainer.append($button);
			}
		);
	}

	function getAllCheckedTerms() {
		const terms = [];
		$(
			'.filters__top-filters .filter-select__option input[type="checkbox"]:checked'
		).each(function () {
			const $checkbox = $(this);
			const value = $checkbox.val();
			if (value !== 'clear') {
				terms.push(value);
			}
		});
		return terms;
	}

	function applyFiltersFromUrl() {
		const urlParams = new URLSearchParams(window.location.search);
		const filters = urlParams.get('filters');

		if (filters) {
			const terms = filters.split(',');

			// Temporarily disable change event triggering during initialization
			$('.filter-select__option input[type="checkbox"]').each(
				function () {
					const $checkbox = $(this);
					if (terms.includes($checkbox.val())) {
						// Set checked without triggering change event
						$checkbox[0].checked = true;
					}
				}
			);

			// Manually sync real selects after setting checkboxes
			$('.filter-select').each(function () {
				const $selectBox = $(this);
				const $checkboxes = $selectBox.find(
					'.filter-select__option input[type="checkbox"]'
				);
				const $realSelect = $selectBox.find('select.real-select');
				if ($checkboxes.length && $realSelect.length) {
					syncRealSelect($checkboxes, $realSelect);
				}
			});

			updateChoises();
			// Don't call AJAX here - initial load is server-rendered
			// Only call AJAX if user changes filters
		} else {
			updateChoises();
		}
	}

	function performAjaxFilterRequest(page = 1) {
		// Don't perform AJAX during initialization (initial content is server-rendered)
		if (isInitializing) {
			return;
		}

		// Check if ajax_object is defined
		// eslint-disable camelcase
		if (
			typeof ajax_object === 'undefined' ||
			!ajax_object ||
			!ajax_object.ajax_url
		) {
			console.warn('ajax_object is not defined');
			return;
		}
		// eslint-enable camelcase

		const selectedTerms = getAllCheckedTerms();

		$.ajax({
			// eslint-disable-next-line camelcase
			url: ajax_object.ajax_url,
			type: 'GET',
			data: {
				action: 'filter_success_stories',
				page,
				terms: selectedTerms,
			},
			beforeSend() {
				if ($preloader) {
					$preloader.classList.add('animate');
				}
			},
			success(response) {
				if (response.success) {
					$('.filters__content-inner').html(response.data);
					if ($preloader) {
						$preloader.classList.remove('animate');
					}
					setupCardCategoryButtons();
					setCurrentPagination(page);
					var onFancyboxReady = window.mobidevOnFancyboxReady || function (cb) {
						if ($.fn && $.fn.fancybox) {
							cb();
						}
					};
					onFancyboxReady(function () {
						$('a[data-fancybox]').fancybox({
							padding: 10,
						});
					});

					// Hide pagination if only 1 page
					const $pagination = $('.filter__pagination');
					if ($pagination.length) {
						// Check if pagination has only prev/next buttons (no page numbers)
						const $pageNumbers = $pagination.find(
							'.pagination__page:not(.prev):not(.next):not([data-paged="1"]):not([data-paged="' +
								$pagination
									.find('.pagination__page')
									.last()
									.data('paged') +
								'"])'
						);
						// If total pages is 1, pagination template won't render, but check anyway
						const hasMultiplePages =
							$pagination.find('.pagination__page.current')
								.length > 0 ||
							$pagination.find('.pagination__page:not(.disabled)')
								.length > 2;
						if (!hasMultiplePages && $pageNumbers.length === 0) {
							$pagination.hide();
						}
					}
				} else {
					$('.filters__content-inner').html(
						'<p>White papers not found</p>'
					);
				}
			},
			error(xhr, status, error) {
				if ($preloader) {
					$preloader.classList.remove('animate');
				}
				// Only show error if we're not initializing (to avoid overwriting server-rendered content)
				if (!isInitializing) {
					console.error('AJAX error:', status, error);
					$('.filters__content-inner').html('<p>Error request</p>');
				}
			},
		});
	}

	function syncRealSelect($checkboxes, $realSelect) {
		if (!$checkboxes.length || !$realSelect.length) {
			return;
		}

		const selectedValues = $checkboxes
			.filter(':checked')
			.map(function () {
				return this.value;
			})
			.get();

		$realSelect.find('option').each(function () {
			$(this).prop('selected', selectedValues.includes(this.value));
		});

		// Don't trigger change event during initialization to prevent cascading AJAX
		if (!isInitializing) {
			$realSelect.trigger('change');
		}
	}

	function setupResetFiltersHandler() {
		$(document).on('click', '.reset-filters', function () {
			$('.filter-select__option input[type="checkbox"]').prop(
				'checked',
				false
			);
			updateChoises();
			updateUrlParams();
		});
	}

	function openFilter($selectBox, $options) {
		if (!$selectBox.length || !$options.length) {
			return;
		}
		$selectBox.addClass('active');
		$selectBox.find('.filter-select__trigger').attr('aria-expanded', 'true');
		$options.stop(true, true).slideDown(400);
	}

	function closeFilter($selectBox, $options) {
		if (!$selectBox.length || !$options.length) {
			return;
		}
		$selectBox.removeClass('active');
		$selectBox.find('.filter-select__trigger').attr('aria-expanded', 'false');
		$options.stop(true, true).slideUp(400);
	}

	function closeAllFilters() {
		$('.filter-select')
			.removeClass('active')
			.find('.filter-select__options')
			.stop(true, true)
			.slideUp(400);
	}

	function setCurrentPagination(page) {
		$('.pagination__page').removeClass('current');
		$('.pagination__page').each(function () {
			if ($(this).text().trim() === page.toString()) {
				$(this).addClass('current');
			}
		});
	}

	$(document).on('click', '.filter-choice-btn', function () {
		const valueToRemove = $(this).data('value');

		$(
			`.filter-select__option input[type="checkbox"][value="${valueToRemove}"]`
		)
			.prop('checked', false)
			.trigger('change');

		$(this).remove();
	});

	$(document).on(
		'change',
		'.filters__top-filters .filter-select__option input[type="checkbox"]',
		function () {
			// Don't trigger AJAX during initialization (initial content is server-rendered)
			if (isInitializing) {
				return;
			}
			performAjaxFilterRequest();
		}
	);

	$(document).on('click', '.pagination__page', function (e) {
		// Don't handle clicks on disabled pagination items
		if ($(this).hasClass('disabled')) {
			return;
		}

		// Don't handle clicks on ellipsis (no link inside)
		if ($(this).find('.pagination__elipsis').length > 0) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		const $pageDiv = $(this);
		const $link = $pageDiv.find('a');

		// If no link found, don't proceed
		if (!$link.length) {
			return;
		}

		let href = $link.attr('href');

		if (!href) {
			// Try to get page from data attribute and build URL
			const page = $pageDiv.data('paged') || 1;
			if (page > 0) {
				// Build URL based on current location
				const basePath = window.location.pathname.replace(
					/\/page\/\d+\/?$/,
					''
				);
				href =
					page === 1
						? basePath
						: basePath.replace(/\/$/, '') + '/page/' + page + '/';
				if (window.location.search) {
					href += window.location.search;
				}
			} else {
				return;
			}
		}

		// Ensure href is absolute if it's relative
		if (href.startsWith('/')) {
			href = window.location.origin + href;
		} else if (
			!href.startsWith('http://') &&
			!href.startsWith('https://')
		) {
			// Relative URL without leading slash - make it relative to current path
			const currentPath = window.location.pathname
				.replace(/\/page\/\d+\/?$/, '')
				.replace(/\/$/, '');
			href = window.location.origin + currentPath + '/' + href;
		}

		// Extract page number from URL
		const url = new URL(href, window.location.origin);
		let page = 1;

		// Try to get page from URL params
		if (url.searchParams.has('paged')) {
			page = parseInt(url.searchParams.get('paged'), 10) || 1;
		} else if (url.searchParams.has('page')) {
			page = parseInt(url.searchParams.get('page'), 10) || 1;
		} else {
			// Try to get from path (pretty permalinks)
			const pathMatch = url.pathname.match(/\/page\/(\d+)\/?$/);
			if (pathMatch) {
				page = parseInt(pathMatch[1], 10) || 1;
			} else {
				// Fallback to data attribute
				page = $pageDiv.data('paged') || 1;
			}
		}

		// Update URL without reload - use pathname + search + hash
		const newUrl =
			url.pathname + (url.search ? url.search : '') + (url.hash || '');
		history.pushState(null, '', newUrl);

		// Perform AJAX request
		performAjaxFilterRequest(page);

		// Scroll to top of filters section
		setTimeout(() => {
			if ($('.filters').length > 0) {
				$('html, body').animate(
					{
						scrollTop:
							$('.filters').offset().top - $('header').height(),
					},
					500
				);
			}
		}, 500);
	});

	$(window).on('orientationchange', function () {
		location.reload();
	});
});
